module.exports = __webpack_public_path__ + "static/media/gm.9fa63bd9.png";